import moment from 'moment';
import _ from 'lodash';
import formatCurrency from 'format-currency';

class TransactionController {
  constructor($rootScope, $uibModal, $state, $http) {
    "ngInject";
    this.state = $state;
    this.$http = $http;
    this.$rootScope = $rootScope;

    this.transactionList = [];
    this.queryParams = {};

    this.formatCurrency = formatCurrency;


    let self = this;
    this.$http.get(this.baseUrl+name)

    this.opened = {};
    this.open = function($event, elementOpened) {
      $event.preventDefault();
      $event.stopPropagation();
      self.opened[elementOpened] = !self.opened[elementOpened];
    };

    this.datePickerFormat = 'MMM dd, yyyy';
    this.dateOptions = {
      // dateDisabled: disabled,
      formatYear: 'yy',
      maxDate: new Date(2020, 5, 22),
      minDate: new Date(1999,1,1),
      startingDay: 1
    };
  }

  search() {
    let self = this;
    this.$http.post(this.$rootScope.apiHost+"/api/integrations/qb/transactions", self.queryParams, {withCredentials: true}).then(function (success) {
      self.transactionList = success.data;
    });

  }

  currency(value) {
    return formatCurrency(value);
  }


  viewTxn(){

  }





}

export default TransactionController;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/capabilities/transaction/transaction.controller.js